export default [
  {
    category: 'Crypto',
    name: 'Quidli',
    link: 'https://quid.li?ref=remoterocket',
    logo:
      'https://pbs.twimg.com/profile_images/1097973856348852224/9FBfPL9k_400x400.png',
    description:
      'Quidli makes it easy for small businesses and remote companies to buy/share Bitcoin, Ether and Dai with their members.',
  },
  {
    category: 'HR',
    name: 'Remoteteam',
    link: 'https://www.remoteteam.com',
    logo: 'https://logo.clearbit.com/remoteteam.com',
    description:
      'Automated payrolls, time off, HR tools, and compliance for remote companies.',
  },
  {
    category: 'communication',
    name: 'Bluejeans',
    link: 'https://bluejeans.com/',
    logo: 'https://logo.clearbit.com/bluejeans.com',
    description:
      'video conferencing app, great for large groups & live streams',
  },
  {
    category: 'communication',
    name: 'Codeshare',
    link: 'https://codeshare.io/',
    logo:
      'https://photos.angel.co/startups/i/857309-7a392c515201b7bcd7a10ca88a6650b5-medium_jpg.jpg?buster=1443602612',
    description:
      'Browser-based multi-user live code sharing with optional video chat.',
  },
  {
    category: 'communication',
    name: 'Fleep',
    link: 'https://fleep.io/',
    logo: 'https://logo.clearbit.com/fleep.io',
    description: 'Internal chat and collaboration tool for development teams',
  },
  {
    category: 'communication',
    name: 'Floobits',
    link: 'https://floobits.com',
    logo: 'https://logo.clearbit.com/floobits.com',
    description:
      'Remote pair programming with screen share. Integrates with Sublime, IntelliJ, Atom and others',
  },
  {
    category: 'communication',
    name: 'Flowdock',
    link: 'https://www.flowdock.com/',
    logo: 'https://logo.clearbit.com/flowdock.com',
    description:
      'Browser-based group chat for teams. Integrates with GitHub, Jira, Jenkins etc.',
  },
  {
    category: 'communication',
    name: 'Hangouts',
    link: 'http://www.google.com/+/learnmore/hangouts/',
    logo: 'https://logo.clearbit.com/google.com',
    description: 'Chat system, share desktop and video calls.',
  },
  {
    category: 'communication',
    name: 'IRCCloud',
    link: 'https://www.irccloud.com',
    logo: 'https://logo.clearbit.com/irccloud.com',
    description: 'Browser-based IRC client with permanent storage.',
  },
  {
    category: 'communication',
    name: 'Jitsi',
    link: 'https://jitsi.org',
    logo: 'https://logo.clearbit.com/jitsi.org',
    description: 'Multi-platform open-source video conferenci',
  },
  {
    category: 'communication',
    name: 'Precursor',
    link: 'https://precursorapp.com',
    logo: 'https://logo.clearbit.com/precursorapp.com',
    description:
      'Simple prototyping & brainstorming web app with real-time collaboration.',
  },
  {
    category: 'communication',
    name: 'PukkaTeam',
    link: 'https://www.pukkateam.com',
    logo: 'https://logo.clearbit.com/pukkateam.com',
    pricing: '$7',
    description:
      'Real team presence through regular automated selfies and one-click video calling',
  },
  {
    category: 'communication',
    name: 'Rocket',
    link: 'https://rocket.chat/',
    logo:
      'https://xebialabs.com/wp-content/uploads/2018/10/Rocketchat-logo.jpg',
    description: '— The Ultimate Open Source WebChat Platform.',
  },
  {
    category: 'communication',
    name: 'Signal',
    link: 'https://signal.org/',
    logo:
      'https://upload.wikimedia.org/wikipedia/commons/a/a9/Signal_ultramarine_icon.png',
    description: 'Encrypted, secure chat and video calls.',
  },
  {
    category: 'communication',
    name: 'Skype',
    link: 'https://www.skype.com/',
    logo: 'https://logo.clearbit.com/skype.com',
    description: 'Video calls.',
  },
  {
    category: 'communication',
    name: 'Slack',
    link: 'https://slack.com/',
    logo: 'https://logo.clearbit.com/slack.com',
    description:
      'Text, voice, and video chat system with loads of integration options including ScreenHero, a real-time, HD screen sharing system for collaboration in teams',
  },
  {
    category: 'communication',
    name: 'Talky',
    link: 'https://talky.io/',
    logo: 'https://logo.clearbit.com/talky.io',
    description: '— Truly simple video chat and screen sharing for groups',
  },
  {
    category: 'communication',
    name: 'TeamHub',
    link: 'https://teamhub.app/',
    logo:
      'https://plugins.jetbrains.com/files/11955/75925/icon/META-INF_pluginIcon.svg',
    description:
      '— Realtime status and progress reporting directly inside your IDE',
  },
  {
    category: 'communication',
    name: 'Twist',
    link: 'https://twist.com/',
    logo: 'https://logo.clearbit.com/twist.com',
    description:
      '— A communications platform where long-form discussions and casual messaging live in harmony.',
  },
  {
    category: 'communication',
    name: 'Whereby',
    link: 'https://whereby.com',
    logo: 'https://logo.clearbit.com/whereby.com',
    description: 'Browser-based, plugin-less group video calls.',
  },
  {
    category: 'communication',
    name: 'Zoom',
    link: 'https://zoom.us/',
    logo: 'https://logo.clearbit.com/zoom.us',
    description:
      'High-quality group video and sharing screen, run on linux, record session and support telephone call',
  },
  {
    category: 'Project Management',
    name: 'Asana',
    link: 'https://asana.com/',
    logo: 'https://logo.clearbit.com/asana.com',
    description: 'Project management good for distributed teams.',
  },
  {
    category: 'Project Management',
    name: 'Clubhouse',
    link: 'https://clubhouse.io/',
    logo: 'https://logo.clearbit.com/clubhouse.io',
    description: 'Project management for software development teams.',
  },
  {
    category: 'Project Management',
    name: 'Harvest',
    link: 'https://www.getharvest.com/',
    logo: 'https://logo.clearbit.com/getharvest.com',
    description: 'Time tracking',
  },
  {
    category: 'Project Management',
    name: 'Hitask',
    link: 'https://hitask.com/',
    logo: 'https://logo.clearbit.com/remoteteam.com',
    description: 'Easy task and project management for teams.',
  },
  {
    category: 'Project Management',
    name: 'Outplanr',
    link: 'https://www.outplanr.com/',
    logo: 'https://logo.clearbit.com/outplanr.com',
    description: 'Project and task management tool.',
  },
  {
    category: 'Project Management',
    name: 'Taskade',
    link: 'https://taskade.com/',
    logo: 'https://logo.clearbit.com/taskade.com',
    description:
      'Real-time collaborative notes, checklists and outlines for teams.',
  },
  {
    category: 'Project Management',
    name: 'Trello',
    link: 'https://trello.com/',
    logo: 'https://logo.clearbit.com/trello.com',
    description: 'Lean project boards.',
  },
  {
    category: 'Project Management',
    name: 'Notion',
    link: 'http://notion.so/',
    logo: 'https://logo.clearbit.com/notion.so',
    description:
      'All in one workspace to write, plan, collaborate, and get organized.',
  },
  {
    category: 'Project Management',
    name: 'Jira',
    link: 'https://www.atlassian.com/software/jira',
    logo: 'https://logo.clearbit.com/atlassian.com',
    description: 'Issue and project tracking tool',
  },
  {
    category: 'Others',
    name: 'Coffitivity',
    link: 'https://coffitivity.com/',
    logo: 'https://logo.clearbit.com/coffitivity.com',
    description:
      'Coffitivity recreates the ambient sounds of a cafe to boost your creativity and help you work better.',
  },
  {
    category: 'Others',
    name: 'Fiverr',
    link: 'https://www.fiverr.com/',
    logo: 'https://logo.clearbit.com/fiverr.com',
    description:
      "Fiverr is the world's largest freelance services marketplace for lean entrepreneurs, where you can hire remote workers to do small tasks for you.",
  },
  {
    category: 'Others',
    name: 'Funretro',
    link: 'https://funretro.io/',
    logo: 'https://logo.clearbit.com/funretro.io',
    description:
      'Funretro is a retrospective online board for distributed team',
  },
  {
    category: 'Others',
    name: 'Listen to Wikipedia (Hatnote)',
    link: 'http://listen.hatnote.com',
    logo: 'https://logo.clearbit.com/hatnote.com',
    description: "Listen to the sound of Wikipedia's recent changes feed.",
  },
  {
    category: 'Others',
    name: 'Noisli',
    link: 'https://www.noisli.com/',
    logo: 'https://logo.clearbit.com/noisli.com',
    description:
      'Noisli has a list of diferent ambient sounds that can be combined to boost creativity and focus.',
  },
  {
    category: 'Others',
    name: 'musicforprogramming',
    link: 'https://musicforprogramming.net/',
    logo:
      'https://i.pinimg.com/originals/b3/22/52/b322523d16a85bbecad270ca2002ad22.jpg',
    description:
      "`return 'A series of mixes intended for listening while '+task+' to aid concentration and increase productivity (also compatible with other activities).';`",
  },
  {
    category: 'Others',
    name: 'Qbserve',
    link: 'https://qotoqot.com/qbserve/',
    logo: 'https://logo.clearbit.com/qotoqot.com',
    description:
      'Time tracking automation: freelance project tracking, timesheets, invoicing & real-time productivity feedback (Mac).',
  },
  {
    category: 'Others',
    name: 'Realtime Board',
    link: 'https://realtimeboard.com/',
    logo: 'https://logo.clearbit.com/realtimeboard.com',
    description: 'Distributed permanent virtual whiteboard.',
  },
  {
    category: 'Others',
    name: 'Teleport Sundial',
    link: 'https://sundial.teleport.org/',
    logo: 'https://logo.clearbit.com/sundial.teleport.org',
    description: 'Manage the locations and timezones of your distributed team',
  },
  {
    category: 'Others',
    name: 'Timing',
    link: 'https://timingapp.com/',
    logo: 'https://logo.clearbit.com/timingapp.com',
    description:
      'Automatic time and productivity tracking for Mac. Helps you stay on track with your work (especially important when working remotely). Also ensures that no billable hours get lost if you are billing hourly (Mac).',
  },
];
